var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-product ps-product--wide ps-product--search-result"},[_c('div',{staticClass:"ps-product__content"},[_c('a',{staticClass:"ps-product__title",staticStyle:{"text-align":"start"},attrs:{"href":`/search?q=${_vm.product.suggestion}`}},[_vm._v("\n          "+_vm._s(_vm.product.suggestion)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }